export class LocationInfo {
    constructor() {
        this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
     getTimezone() {
        return this.timezone;
    }
     isAmerica(){
        return this.timezone.includes('America');
    }
     isEurope(){
        return this.timezone.includes('Europe');
    }
}
